import { useEffect, useState } from "react";

const STORAGE_KEY = "because-fm-night-paper";
const FONT_KEY = "because-fm-reader-font";
export const MIN_FONT_SCALE = .85;
export const MAX_FONT_SCALE = 1.25;

export function useNightPaper() {
  const [night, setNight] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored !== null) return stored === "1";
    } catch { /* приватный режим не должен ломать чтение */ }
    return window.matchMedia?.("(prefers-color-scheme: dark)").matches ?? false;
  });
  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, night ? "1" : "0"); } catch { /* см. выше */ }
  }, [night]);
  return [night, setNight] as const;
}

/**
 * Кегль ридера. Раньше это был `useState(1)`: ночная бумага помнилась, а размер
 * шрифта сбрасывался при каждом открытии каждой истории — читатель с неидеальным
 * зрением жал «+» заново по четыре раза.
 *
 * Остаётся на устройстве и не уезжает в аккаунт намеренно, в отличие от места
 * остановки: где читатель остановился — свойство истории и обязано ехать за ним,
 * а комфортный кегль — свойство экрана, и телефон с 27-дюймовым монитором честно
 * хотят разного.
 */
export function useReaderFont() {
  const [fontScale, setFontScale] = useState(() => {
    try {
      const stored = Number(localStorage.getItem(FONT_KEY));
      if (Number.isFinite(stored) && stored > 0) return Math.min(MAX_FONT_SCALE, Math.max(MIN_FONT_SCALE, stored));
    } catch { /* приватный режим не должен ломать чтение */ }
    return 1;
  });
  useEffect(() => {
    try { localStorage.setItem(FONT_KEY, String(fontScale)); } catch { /* см. выше */ }
  }, [fontScale]);
  return [fontScale, setFontScale] as const;
}
